import { Link } from "react-router-dom";

// Mirror of backend domains/social/mentions.py token rules.
const RICH_RE = /(?<![\w#@.])([#@])([A-Za-z0-9_][A-Za-z0-9_.]*)/g;

/** Renders post/comment text with clickable #hashtags and @mentions. Keeps line breaks. */
export function RichText({ text, className = "" }) {
    if (!text) return null;
    const nodes = [];
    let last = 0, key = 0, m;
    RICH_RE.lastIndex = 0;
    while ((m = RICH_RE.exec(text)) !== null) {
        const sym = m[1];
        const raw = m[2];
        const start = m.index;
        if (start > last) nodes.push(text.slice(last, start));

        if (sym === "#") {
            const clean = (raw.match(/^[A-Za-z0-9_]+/) || [""])[0];
            const rest = raw.slice(clean.length);
            if (clean && !/^\d+$/.test(clean)) {
                nodes.push(
                    <Link key={key++} to={`/tags/${clean.toLowerCase()}`} onClick={(e) => e.stopPropagation()} className="text-[#ff4500] hover:underline">#{clean}</Link>
                );
            } else {
                nodes.push(`#${clean}`);
            }
            if (rest) nodes.push(rest);
        } else {
            const uname = raw.replace(/\.+$/, "");
            const trailing = raw.slice(uname.length);
            nodes.push(
                <Link key={key++} to={`/u/${uname.toLowerCase()}`} onClick={(e) => e.stopPropagation()} className="text-[#4aa3f0] hover:underline">@{uname}</Link>
            );
            if (trailing) nodes.push(trailing);
        }
        last = start + sym.length + raw.length;
    }
    if (last < text.length) nodes.push(text.slice(last));
    return <span className={className} style={{ whiteSpace: "pre-line", wordBreak: "break-word" }} data-testid="rich-text">{nodes}</span>;
}

export default RichText;
